module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "component-credit-bonus-configuration"
  }, [_c('ModalReveal', {
    ref: "bonusModal",
    on: {
      "modalOpen": _vm.load
    }
  }, [(_vm.item.amount !== null) ? _c('button', {
    staticClass: "button",
    attrs: {
      "slot": "trigger"
    },
    slot: "trigger"
  }, [_vm._v("Info")]) : _vm._e(), (_vm.info !== null) ? _c('div', {
    staticClass: "row text-center"
  }, [(_vm.checkConfig.length) ? [_c('div', {
    staticClass: "column"
  }, [_c('h2', [_vm._v("Used Amount")]), _c('h3', [_vm._v(_vm._s(_vm.$priceWithcurrency(_vm.info.used_amount)))])]), _c('div', {
    staticClass: "column"
  }, [_c('h2', [_vm._v("Amount Left")]), _c('h3', [_vm._v(_vm._s(_vm.$priceWithcurrency(_vm.info.amount_left)))])])] : _vm._e(), _c('div', {
    staticClass: "column"
  }, [_c('h2', [_vm._v("Use count")]), _c('h3', [_vm._v(_vm._s(_vm.info.use_count))])])], 2) : _vm._e()])], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-0e1a8854!./~/vue-loader/lib/template-loader.js?raw&engine=pug!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/backoffice/configuration/CreditBonusInformation.vue
// module id = 2261
// module chunks = 1